export default __webpack_public_path__ + "static/media/checkmark_teal.6326464f.svg";